<template>
  <section class="section has-background-black">
    <div class="container">
      <h1 class="title is-3 has-text-weight-bold has-text-light is-capitalized">Select Your Zone</h1>
      <h2
        class="subtitle has-text-light is-6"
      >or scroll to discover all Knockouts across Delhi and Delhi NCR</h2>

      <!-- scrolling program menu -->
      <div class="columns scrolling-wrapper">
        <div
          id="hoverDiv"
          class="column card drop-shadow"
          v-for="(program, index) in mma_beginners"
          :key="index"
          :style="{ backgroundImage: 'url(' + program.img + ')' }"
          v-scroll-to="{el: '#' + program.id, offset: -60 }"
        >
          <div class="gradient">
            <span v-if="program.popular" class="popular is-unselectable"></span>

            <div class="block">
              <h2
                class="is-uppercase has-text-weight-bold is-unselectable has-text-light"
              >{{ program.name }}</h2>
              <!-- <p class="is-size-7">{{ program.desc }}</p> -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  methods: {
    clickMethod(hash) {
      this.$router.push("#" + hash);
    }
  },
  data() {
    return {
      mma_beginners: [
        {
          name: "East Delhi",
          id: "east-delhi",
          //   desc: "Learn Basics of Boxing in 60 days",
          //   popular: true
          img: require("@/assets/branches/east.jpg")
        },
        {
          name: "West Delhi",
          id: "west-delhi",
          //   desc: "Start Boxing asap",
          img: require("@/assets/branches/west.jpg")
        },
        // {
        //   name: "North Delhi",
        //   id: "north-delhi",
        //   active: false
        //   //   desc: "Start Boxing asap",
        // img: require("../assets/branches/north.jpg")
        // },
        {
          name: "South Delhi",
          id: "south-delhi",
          //   desc: "Start Boxing asap",
          img: require("@/assets/branches/south.jpg")
        },
        {
          name: "Delhi NCR",
          id: "delhi-ncr",
          //   desc: "MMA Introduction",
          img: require("@/assets/branches/ncr.jpg")
        }
      ]
    };
  }
};
</script>

<style lang="scss" scoped>
#hoverDiv {
  cursor: pointer;
  transition: transform 0.1s; /* Animation */
}

#hoverDiv:hover {
  transform: scale(1.05);
}

.card {
  background-position: center center;
  background-repeat: no-repeat;
  background-size: contain;
  border-radius: 10px;
  // border: 6px solid #131313;
}
.popular {
  position: absolute;
  top: -16px;
  right: -15px;
  background-color: red;
  color: white;
  border-radius: 200008908px;
  padding: 5px;
  font-size: 0.55rem;
  text-transform: uppercase;
  font-family: Open Sans, Open Sans Hebrew, Arial;
  font-weight: 700;
}

.popular:after {
  content: "most popular";
}

.heading-line {
  position: relative;
  padding-bottom: 20px;
}

.section-title.heading-line {
  padding-bottom: 14px;
}

.heading-line:after {
  content: "";
  position: absolute;
  bottom: 0px;
  height: 5px;
  left: 0px;
  width: 69px;
  background: red;
}

.scrolling-wrapper {
  padding-top: 2rem;
  display: flex;
  flex-wrap: nowrap;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  // Disable visible scroll bars
  &::-webkit-scrollbar {
    display: none;
  }

  .card {
    flex: 0 0 auto;
    padding: 20px;
    margin: 10px;
    height: 200px;
    width: 200px;
    background-color: #131313;
    color: whitesmoke;
  }
}

.card {
  flex: 0 0 auto;
  padding: 20px;
  margin: 10px;
  height: 200px;
  width: 200px;
  background-color: #131313;
  color: whitesmoke;
}

.scrolling-wrapper {
  -webkit-overflow-scrolling: touch;
}

.scrolling-wrapper {
  &::-webkit-scrollbar {
    display: none;
  }
}

.gradient {
  background-image: linear-gradient(
    rgba(30, 30, 30, 1),
    rgba(0, 0, 0, 0.5),
    #ffffff00
  );
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  padding: 2em;
  border-radius: 10px;
  word-wrap: break-word;
}
</style>
